<template>
    <div>
        <h6 class="text-muted font-semibold mb-5">
            {{ $trans.get('__JSON__.Timeline') }}
        </h6>
        <div class="list-group list-group-flush list-group-borderless">
            <div class="list-group-item px-2 py-0" v-for="status in data.statuses">
                <div class="border-start">
                    <div class="d-flex ms-n2 pb-6">
                        <div class="flex-none me-3">
                            <i class="text-base text-muted" :class="status.icon" v-if="status.icon"></i>
                            <div class="icon icon-shape text-sm w-4 h-4 rounded-circle" :class="status.color" v-else></div>
                        </div>
                        <div>
                            <div class="h6 font-semibold lh-none text-heading text-primary-hover d-inline-block mb-1">
                                {{ status.title }}
                            </div>
                            <div>
                                <span v-html="status.body" />
                            </div>
                            <div>
                                <small class="text-xs text-muted">
                                    {{ status.date.human }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="list-group-item px-2 py-0" v-if="data.info">
                <div class="border-start">
                    <div class="d-flex ms-n2 pb-6">
                        <div class="flex-none me-3">
                            <i class="text-base text-muted bi bi-person-fill-add"></i>
                        </div>
                        <div>
                            <div class="h6 font-semibold lh-none text-heading text-primary-hover d-inline-block mb-1">
                                {{ data.info.fullName }}
                            </div>
                            <div>
                                {{ $trans.get('__JSON__.:count placements', { count: data.info.totalPlacements }) }}<br />
                                {{ $trans.get('__JSON__.:total hours worked in total', { total: data.info.totalHoursWorked }) }}<br />
                                {{ $trans.get('__JSON__.last worked on :date', { date: data.info.lastWorkingDay }) }}<br />
                                {{ $trans.get('__JSON__.employment since :date', { date: data.info.date.readable }) }}
                            </div>
                            <div>
                                <small class="text-xs text-muted">
                                    {{ data.info.date.human }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RequestHandler from "../mixins/RequestHandler";
import DateHelpers from "../mixins/DateHelpers";

export default {
    name: 'ContractStatus',
    mixins: [ DateHelpers, RequestHandler ],
    props: {
        userId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            collapsed: true,
            loading: false,
            data: {},
        }
    },
    watch: {
        userId() {
            this.fetch()
        },
    },
    methods: {
        fetch() {
            if (! this.userId) return

            this.loading = true
            this.collapsed = true

            this.makeRequest('post', '/api/contract/status', {
                userId: this.userId,
            }, response => {
                this.data = response.data
                this.$parent.showHistory = true
                this.collapsed = false
            },
            error => console.log(error),
            () => this.loading = false
            )
        },
    },
    mounted() {
        this.fetch()

        let collapse = document.getElementById('contractModal')
        collapse.addEventListener('hide.bs.offcanvas', () => this.collapsed = true)
        collapse.addEventListener('show.bs.offcanvas', () => this.collapsed = false)
    },
}
</script>
